var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 306.4,
    cy: 269.5,
    rx: 32.4,
    ry: 34.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 191.3,
    cy: 269.5,
    rx: 32.4,
    ry: 34.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,2.3C113.2,2.3,2.3,113.2,2.3,250c0,136.8,110.9,247.7,247.7,247.7c136.8,0,247.7-110.9,247.7-247.7 C497.7,113.2,386.8,2.3,250,2.3z M392.3,368.8c-25.4,12-53.6,12.4-53.6,12.4l-21.1-25.7c0,0,18.9-5.1,35-16 c15.7-10.6,21.9-21.3,21.9-21.3s-55.6,36.3-119,36.3c-1.7,0-3.3-0.1-4.8-0.1c-1.5,0.1-3.1,0.1-4.8,0.1c-63.4,0-119-36.3-119-36.3 s12.3,14.6,21.9,21.3c9.6,6.7,33.8,15.8,33.8,15.8l-20.8,25.8c0,0-29.4-0.7-55-12.1c-25.6-11.4-42.1-35-42.1-35S66,276.1,76,240.3 c10-35.8,34.2-89.2,34.2-89.2s4.6-5.8,36.4-20c31.8-14.2,52.8-12.1,52.8-12.1l3.3,3.3c0,0-22.9,6.7-44.6,16.7 c-21.7,10-37.2,23.7-37.2,23.7s48.9-29.6,125.1-31.1c1.1,0,2.2-0.1,3.3-0.1c0.5,0,0.9,0,1.4,0c0.5,0,1,0,1.5,0c1.3,0,2.6,0,3.9,0.1 c70.9,1.8,118.7,31.3,118.7,31.3s-16-14-37.7-24c-21.7-10-41.4-15.3-41.4-15.3l4.7-4.7c0,0,22.8-1.9,54.6,12.2 c26.1,11.5,34.9,20.8,34.9,20.8s18.2,34.6,33.1,87.8c10,35.8,12.2,92.8,12.2,92.8S425,353.4,392.3,368.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialDiscord);
export default __webpack_public_path__ + "static/media/social_discord.3bc36500a0828141d2294dfd92d2c073.svg";
export { ForwardRef as ReactComponent };